export const dataId = {
  type: 'string',
  minLength: 1,
};
